module.exports = __webpack_public_path__ + "static/img/deal@2x.e857c43f.png";